export const Icons = {
  Trending: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#a)">
        <g>
          <g>
            <g fill="#DD2928">
              <path d="M8 4C5.792 4 4 5.792 4 8s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4"></path>
              <path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m0 14.4A6.4 6.4 0 0 1 1.6 8c0-3.536 2.864-6.4 6.4-6.4s6.4 2.864 6.4 6.4-2.864 6.4-6.4 6.4"></path>
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  Fire: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <g clipPath="url(#a)">
        <g>
          <path
            fill="url(#b)"
            d="M11.62 6.193a.094.094 0 0 0-.115-.03.1.1 0 0 0-.065.106q.013.127.014.255c.004.352-.137.697-.387.946a1.27 1.27 0 0 1-.923.377c-.475-.006-.869-.253-1.14-.716-.223-.383-.125-.876-.02-1.399.06-.305.123-.622.123-.923 0-2.343-1.575-3.695-2.514-4.292A.1.1 0 0 0 6.538.5a.1.1 0 0 0-.058.018.09.09 0 0 0-.042.1c.36 1.906-.711 3.053-1.845 4.267C3.425 6.135 2.1 7.554 2.1 10.11A5.395 5.395 0 0 0 7.49 15.5c2.446 0 4.603-1.706 5.245-4.148.438-1.665-.02-3.787-1.115-5.159M7.624 14.35a2.68 2.68 0 0 1-1.992-.75 2.72 2.72 0 0 1-.842-1.958c0-1.375.526-2.384 1.94-3.725a.1.1 0 0 1 .114-.018c.024.012.062.04.057.1-.05.589-.05 1.077.003 1.452.133.958.834 1.601 1.744 1.601.446 0 .871-.168 1.196-.473a.1.1 0 0 1 .097-.027c.021.005.05.018.065.054.135.326.204.672.205 1.028.004 1.433-1.156 2.652-2.587 2.716"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="7.5"
          x2="7.5"
          y1="0.5"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6F6F7"></stop>
          <stop offset="1" stopColor="#666"></stop>
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 .5h15v15H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  FireWhite: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      fill="none"
      viewBox="0 0 15 16"
    >
      <g clipPath="url(#a)">
        <g>
          <path
            fill="url(#b)"
            d="M11.62 6.193a.094.094 0 0 0-.115-.03.1.1 0 0 0-.065.106q.013.127.014.255c.004.352-.137.697-.387.946a1.27 1.27 0 0 1-.923.377c-.475-.006-.869-.253-1.14-.716-.223-.383-.125-.876-.02-1.399.06-.305.123-.622.123-.923 0-2.343-1.575-3.695-2.514-4.292A.1.1 0 0 0 6.538.5a.1.1 0 0 0-.058.018.09.09 0 0 0-.042.1c.36 1.906-.711 3.053-1.845 4.267C3.425 6.135 2.1 7.554 2.1 10.11A5.395 5.395 0 0 0 7.49 15.5c2.446 0 4.603-1.706 5.245-4.148.438-1.665-.02-3.787-1.115-5.159M7.624 14.35a2.68 2.68 0 0 1-1.992-.75 2.72 2.72 0 0 1-.842-1.958c0-1.375.526-2.384 1.94-3.725a.1.1 0 0 1 .114-.018c.024.012.062.04.057.1-.05.589-.05 1.077.003 1.452.133.958.834 1.601 1.744 1.601.446 0 .871-.168 1.196-.473a.1.1 0 0 1 .097-.027c.021.005.05.018.065.054.135.326.204.672.205 1.028.004 1.433-1.156 2.652-2.587 2.716"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="7.5"
          x2="7.5"
          y1="0.5"
          y2="15.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 .5h15v15H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  Images: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill="#727177" clipPath="url(#a)">
        <path d="M4.166 12.354a2.5 2.5 0 0 1-2.361-1.7l-.023-.077a2.4 2.4 0 0 1-.116-.723V5.31L.05 10.707a1.514 1.514 0 0 0 1.061 1.837l10.31 2.76q.193.05.383.05c.664 0 1.27-.44 1.441-1.09l.6-1.91zM6 5.354a1.335 1.335 0 0 0 0-2.667c-.736 0-1.334.598-1.334 1.333 0 .736.598 1.334 1.333 1.334"></path>
        <path d="M14.333.687h-10a1.67 1.67 0 0 0-1.667 1.667v7.333c0 .919.748 1.667 1.667 1.667h10c.919 0 1.667-.748 1.667-1.667V2.354A1.67 1.67 0 0 0 14.333.687m-10 1.333h10c.184 0 .333.15.333.334v4.733L12.56 4.629a1.2 1.2 0 0 0-.894-.41c-.345.002-.67.155-.89.42L8.299 7.613l-.806-.805a1.17 1.17 0 0 0-1.654 0L4 8.647V2.354c0-.184.15-.334.334-.334"></path>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  Telegram: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="url(#a)"
        d="M19.96 2.106a.43.43 0 0 0-.291-.316 1.5 1.5 0 0 0-.787.056S1.359 8.144.358 8.84c-.216.15-.288.237-.324.34-.173.497.366.715.366.715l4.516 1.472a.5.5 0 0 0 .229-.013c1.027-.65 10.337-6.528 10.875-6.725.084-.026.147 0 .133.062-.22.754-8.26 7.898-8.304 7.942a.17.17 0 0 0-.062.147l-.42 4.407s-.176 1.375 1.196 0a38 38 0 0 1 2.375-2.172c1.553 1.072 3.224 2.257 3.945 2.875a1.25 1.25 0 0 0 .915.354c.687-.027.875-.779.875-.779s3.193-12.846 3.3-14.568c.01-.169.024-.277.026-.393a1.4 1.4 0 0 0-.04-.399"
      ></path>
      <defs>
        <linearGradient
          id="a"
          x1="10"
          x2="10"
          y1="1.761"
          y2="18.245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E9EA6"></stop>
          <stop offset="1" stopColor="#3D3D40"></stop>
        </linearGradient>
      </defs>
    </svg>
  ),
  Twitter: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#a)">
        <path
          fill="url(#b)"
          d="M20.001 3.813c-.75.312-1.5.562-2.375.625.875-.5 1.5-1.313 1.813-2.25-.813.5-1.688.812-2.625 1-.75-.813-1.813-1.313-2.938-1.313A4.12 4.12 0 0 0 9.751 6c0 .313.062.625.125.938-3.438-.188-6.438-1.813-8.5-4.313a3.93 3.93 0 0 0-.563 2.063c0 1.437.75 2.687 1.813 3.437a3.8 3.8 0 0 1-1.875-.5v.063c0 2 1.437 3.625 3.312 4-.375.063-.687.125-1.062.125-.25 0-.5 0-.75-.062.5 1.625 2.062 2.812 3.812 2.875-1.375 1.125-3.187 1.75-5.125 1.75-.312 0-.687 0-1-.063 1.875 1.125 4.063 1.813 6.375 1.813 7.563 0 11.688-6.25 11.688-11.688v-.5c.75-.625 1.438-1.313 2-2.125"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="9.97"
          x2="9.97"
          y1="1.875"
          y2="18.125"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E9EA6"></stop>
          <stop offset="1" stopColor="#3D3D40"></stop>
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  Discord: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill="url(#a)"
        d="M16.93 3.642a16.5 16.5 0 0 0-4.07-1.263.06.06 0 0 0-.066.03 12 12 0 0 0-.506 1.042 15.2 15.2 0 0 0-4.573 0 11 11 0 0 0-.514-1.041.06.06 0 0 0-.066-.031 16.5 16.5 0 0 0-4.07 1.263.06.06 0 0 0-.028.023C.445 7.538-.266 11.317.083 15.048a.07.07 0 0 0 .026.047 16.6 16.6 0 0 0 4.994 2.524.06.06 0 0 0 .07-.023q.58-.788 1.022-1.661a.063.063 0 0 0-.035-.088 11 11 0 0 1-1.56-.744.064.064 0 0 1-.007-.106q.159-.119.31-.243a.06.06 0 0 1 .065-.009c3.273 1.495 6.817 1.495 10.051 0a.06.06 0 0 1 .066.008q.15.124.31.244a.064.064 0 0 1-.005.106q-.747.435-1.561.743a.064.064 0 0 0-.034.089c.3.581.643 1.135 1.02 1.66a.06.06 0 0 0 .07.024 16.5 16.5 0 0 0 5.003-2.524.06.06 0 0 0 .026-.046c.417-4.314-.699-8.062-2.957-11.384a.05.05 0 0 0-.026-.023M6.684 12.776c-.985 0-1.797-.905-1.797-2.016s.796-2.015 1.797-2.015c1.01 0 1.814.912 1.798 2.015 0 1.111-.796 2.016-1.798 2.016m6.646 0c-.985 0-1.797-.905-1.797-2.016s.796-2.015 1.797-2.015c1.009 0 1.813.912 1.797 2.015 0 1.111-.788 2.016-1.797 2.016"
      ></path>
      <defs>
        <linearGradient
          id="a"
          x1="10"
          x2="10"
          y1="2.378"
          y2="17.622"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E9EA6"></stop>
          <stop offset="1" stopColor="#3D3D40"></stop>
        </linearGradient>
      </defs>
    </svg>
  ),
  Website: (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <mask
        id="a"
        width="20"
        height="20"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#D9D9D9" d="M0 0h20v20H0z"></path>
      </mask>
      <g mask="url(#a)">
        <path
          fill="url(#b)"
          d="M10 18.333a8.1 8.1 0 0 1-3.23-.656 8.5 8.5 0 0 1-2.655-1.792 8.5 8.5 0 0 1-1.792-2.656 8.1 8.1 0 0 1-.656-3.23 8 8 0 0 1 .656-3.239 8.5 8.5 0 0 1 1.792-2.646A8.5 8.5 0 0 1 6.77 2.323 8.1 8.1 0 0 1 10 1.667a8 8 0 0 1 3.239.656 8.5 8.5 0 0 1 2.646 1.791 8.5 8.5 0 0 1 1.791 2.646 8 8 0 0 1 .656 3.24 8.1 8.1 0 0 1-.656 3.229 8.5 8.5 0 0 1-1.791 2.656 8.5 8.5 0 0 1-2.646 1.792 8 8 0 0 1-3.24.656m0-1.708q.542-.75.938-1.563t.645-1.729H8.417q.25.917.646 1.73.395.812.937 1.562m-2.167-.334q-.375-.687-.656-1.427a12 12 0 0 1-.469-1.53H4.25a6.9 6.9 0 0 0 1.51 1.812 6 6 0 0 0 2.073 1.145m4.334 0a6 6 0 0 0 2.073-1.145 6.9 6.9 0 0 0 1.51-1.813h-2.458a12 12 0 0 1-.469 1.531q-.28.74-.656 1.427m-8.625-4.625h2.833a11.008 11.008 0 0 1-.094-2.51q.031-.405.094-.823H3.542A6.633 6.633 0 0 0 3.334 10a6.6 6.6 0 0 0 .208 1.666m4.5 0h3.916q.063-.416.094-.822a11 11 0 0 0 0-1.688q-.03-.405-.094-.823H8.042q-.063.417-.094.823a11 11 0 0 0 0 1.688q.03.406.094.822m5.583 0h2.833q.105-.416.157-.822.051-.407.052-.844a6.6 6.6 0 0 0-.209-1.667h-2.833q.063.417.094.823a11 11 0 0 1 0 1.688q-.031.406-.094.822m-.333-5h2.458a6.9 6.9 0 0 0-1.51-1.812 6 6 0 0 0-2.073-1.146q.375.687.656 1.427t.469 1.532m-4.875 0h3.166a10 10 0 0 0-.645-1.729A10.6 10.6 0 0 0 10 3.375q-.542.75-.937 1.562a10 10 0 0 0-.646 1.73m-4.167 0h2.458q.188-.791.47-1.53.28-.741.655-1.428a6 6 0 0 0-2.072 1.146 6.9 6.9 0 0 0-1.51 1.813"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="b"
          x1="10"
          x2="10"
          y1="1.667"
          y2="18.333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E9EA6"></stop>
          <stop offset="1" stopColor="#3D3D40"></stop>
        </linearGradient>
      </defs>
    </svg>
  ),
};
